

// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import { getSubscriptions } from "../../../Servicefile/clientManagementService.jsx";
// const Foodsubscribedclients = () => {
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedCityFilter, setSelectedCityFilter] = useState("");
//     const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

//     // Search filters - same as FoodPaidClents
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");

//     const { showLoader, hideLoader } = useLoader();
//     const [error, setError] = useState(null);

//     // Business Vertical options
//     const businessVerticalOptions = [
//         "FOOD_AND_BEVERAGES",
//         "CATERINGS_SERVICES",
//         "LOGISTICS_SUPPLY",
//         "FRESH_GROCERIES"
//     ];

//     // Search options - same as FoodPaidClents
//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Customer Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" }
//     ];

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const formatShortDate = (isoString) => {
//         if (!isoString) return "—";
//         try {
//             return new Date(isoString)
//                 .toLocaleDateString("en-GB", {
//                     day: "2-digit",
//                     month: "2-digit",
//                     year: "2-digit",
//                 })
//                 .replaceAll("/", "-");
//         } catch (e) {
//             return "—";
//         }
//     };

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search Vendor ID";
//             case "name": return "Search Customer Name";
//             case "email": return "Search Email";
//             case "phoneNumber": return "Search Mobile Number";
//             case "city": return "Search City";
//             default: return "Search...";
//         }
//     };

//     useEffect(() => {
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             console.warn("⚠️ No authToken found.");
//             setError("Authentication token not found");
//             hideLoader();
//             return;
//         }

//         const fetchSubscriptions = async () => {
//             try {
//                 showLoader();

//                 const subscriptions = await getSubscriptions(token);

//                 console.log("API Response:", subscriptions);

//                 const mapped = (Array.isArray(subscriptions) ? subscriptions : [])
//                     .map((s, idx) => ({
//                         id: s.subscriptionId ?? idx,
//                         vendorName: s.customerName || "—",
//                         vendorId: s.vendorId || "—",
//                         email: s.email || s.customerEmail || "—",
//                         mobileNumber: s.customerMobile || "—",
//                         city: s.city || "—",
//                         businessVertical: s.businessVertical || "—",
//                         startDate: s.startDate,
//                         endDate: s.endDate,
//                         billingCycle: s.billingCycle || "—",
//                         totalAmount: s.totalAmount || 0,
//                         status: s.status || "—",
//                         selectedModules: s.selectedModules || [],
//                         remainingDays: s.remainingDays || 0,
//                         message: s.message || "",
//                     }));

//                 setData(mapped);

//                 setError(null);

//             } catch (err) {
//                 console.error("Error fetching subscriptions:", err);
//                 setError(err.message);

//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchSubscriptions();

//     }, []);

//     // Get unique cities for filter
//     const uniqueCities = useMemo(() => {
//         const cities = data.map(item => item.city).filter(city => city && city !== "—");
//         return [...new Set(cities)].sort();
//     }, [data]);

//     // Get unique statuses for filter
//     const uniqueStatuses = useMemo(() => {
//         const statuses = data.map(item => item.status).filter(Boolean);
//         return [...new Set(statuses)].sort();
//     }, [data]);

//     // Get unique business verticals for filter
//     const uniqueBusinessVerticals = useMemo(() => {
//         const verticals = data.map(item => item.businessVertical).filter(Boolean);
//         return [...new Set(verticals)].sort();
//     }, [data]);

//     // Apply filters - including search filters same as FoodPaidClents
//     const filteredData = useMemo(() => {
//         let result = data;

//         // Apply status filter
//         if (selectedStatusFilter) {
//             result = result.filter(item =>
//                 item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
//             );
//         }

//         // Apply city filter
//         if (selectedCityFilter) {
//             result = result.filter(item =>
//                 item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
//             );
//         }

//         // Apply business vertical filter
//         if (selectedBusinessVerticalFilter) {
//             result = result.filter(item =>
//                 item.businessVertical === selectedBusinessVerticalFilter
//             );
//         }

//         // Apply search query - same as FoodPaidClents
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 // Get the field value based on searchType
//                 let fieldValue;

//                 // Handle different field names
//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.mobileNumber;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email;
//                 } else if (searchType === "name") {
//                     fieldValue = item.vendorName;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue || fieldValue === "—") return false;

//                 // For phone number search, clean non-digits
//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 // For other fields
//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         return result;
//     }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery]);

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSelectedStatusFilter("");
//         setSelectedCityFilter("");
//         setSelectedBusinessVerticalFilter("");
//         setSearchQuery("");
//         setSearchType("vendorId");
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px", }}>
//                     {/* Filter Section - Same layout as FoodPaidClents */}
//                     <div className="row g-2 mb-3 align-items-center me-0">
//                         {/* Search Type Dropdown and Search Input - Side by Side */}
//                         <div className="col-md-auto col-12">
//                             <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                                 {/* Search Type Dropdown */}
//                                 <div style={{ minWidth: '150px' }}>
//                                     <select
//                                         className="form-select"
//                                         value={searchType}
//                                         onChange={(e) => setSearchType(e.target.value)}
//                                         style={{ height: "40px" }}
//                                     >
//                                         {searchOptions.map(option => (
//                                             <option key={option.value} value={option.value}>
//                                                 {option.label}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Search Input */}
//                                 <div style={{ minWidth: '200px' }}>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         placeholder={getPlaceholderText()}
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         style={{ height: "40px" }}
//                                     />
//                                 </div>
//                             </div>
//                         </div>







//                         {/* Clear Filters Button */}
//                         <div className="col-md-auto col-12">
//                             <button
//                                 className="btn"
//                                 onClick={clearAllFilters}
//                                 style={{
//                                     backgroundColor: '#6c757d',
//                                     color: '#fff',
//                                     height: "40px",
//                                     padding: "0 15px"
//                                 }}
//                             >
//                                 Clear Filters
//                             </button>
//                         </div>

//                         {/* Refresh Data Button */}
//                         <div className="col-md col-12">
//                             <div className="d-flex justify-content-start justify-content-md-end">
//                                 <button
//                                     className="btn"
//                                     onClick={() => window.location.reload()}
//                                     style={{
//                                         backgroundColor: 'rgb(230 109 51)',
//                                         color: '#fff',
//                                         height: "40px",
//                                         padding: "0 20px"
//                                     }}
//                                 >
//                                     Refresh Data
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     <div
//                         className="user-management-page"
//                         style={{
//                             overflowY: "auto",
//                             height: "59vh",
//                             scrollbarWidth: "thin",
//                             marginTop: "15px",
//                         }}
//                     >
//                         <div className="user-management-container" style={{ marginLeft: "0px" }}>
//                             <div className="user-table-wrapper">
//                                 <table style={{ width: "100%", fontSize: "0.9rem", borderCollapse: "collapse" }}>
//                                     <thead>
//                                         <tr>
//                                             <th style={tableHeaderStyle}>S.NO</th>
//                                             <th style={tableHeaderStyle}>Customer Name</th>
//                                             <th style={tableHeaderStyle}>Vendor ID</th>
//                                             <th style={tableHeaderStyle}>Email</th>
//                                             <th style={tableHeaderStyle}>Phone</th>
//                                             <th style={tableHeaderStyle}>City</th>
//                                             <th style={tableHeaderStyle}>Vertical</th>
//                                             <th style={tableHeaderStyle}>Billing Cycle</th>
//                                             <th style={tableHeaderStyle}>Amount (₹)</th>
//                                             <th style={tableHeaderStyle}>Start Date</th>
//                                             <th style={tableHeaderStyle}>End Date</th>
//                                             <th style={tableHeaderStyle}>Remaining</th>
//                                             <th style={tableHeaderStyle}>Status</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredData.length === 0 ? (
//                                             <tr>
//                                                 <td colSpan="13" style={tableCellStyle}>
//                                                     {error
//                                                         ? `⚠️ Error: ${error}`
//                                                         : data.length === 0
//                                                             ? "No subscription data found"
//                                                             : "No data matches the selected filters"}
//                                                 </td>
//                                             </tr>
//                                         ) : (
//                                             filteredData.map((item, index) => (
//                                                 <tr key={item.id}>
//                                                     <td style={tableCellStyle}>
//                                                         {index + 1}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         <span style={{ fontWeight: "500" }}>
//                                                             {item.vendorName}
//                                                         </span>
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.vendorId}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.email}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.mobileNumber}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.city}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.businessVertical}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {item.billingCycle}
//                                                     </td>
//                                                     <td style={{ ...tableCellStyle, fontWeight: "600", color: "#0b5e42" }}>
//                                                         {item.totalAmount > 0
//                                                             ? `₹${item.totalAmount.toLocaleString()}`
//                                                             : "—"
//                                                         }
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {formatShortDate(item.startDate)}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         {formatShortDate(item.endDate)}
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         <span style={{
//                                                             color: item.remainingDays < 30 ? "#dc3545" : "#28a745",
//                                                             fontWeight: "bold",
//                                                             backgroundColor: item.remainingDays < 30 ? "#ffe6e6" : "#e6ffe6",
//                                                             padding: "4px 8px",
//                                                             borderRadius: "20px",
//                                                             display: "inline-block"
//                                                         }}>
//                                                             {item.remainingDays || 0}d
//                                                         </span>
//                                                     </td>
//                                                     <td style={tableCellStyle}>
//                                                         <span style={{
//                                                             padding: "4px 12px",
//                                                             borderRadius: "20px",
//                                                             backgroundColor:
//                                                                 item.status === "ACTIVE" ? "#d4edda" :
//                                                                     item.status === "EXPIRED" ? "#f8d7da" :
//                                                                         item.status === "PENDING" ? "#fff3cd" :
//                                                                             "#e2e3e5",
//                                                             color:
//                                                                 item.status === "ACTIVE" ? "#155724" :
//                                                                     item.status === "EXPIRED" ? "#721c24" :
//                                                                         item.status === "PENDING" ? "#856404" :
//                                                                             "#383d41",
//                                                             fontWeight: "600",
//                                                             display: "inline-block"
//                                                         }}>
//                                                             {item.status}
//                                                         </span>
//                                                     </td>
//                                                 </tr>
//                                             ))
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Styles
// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "rgb(230 109 51)",
//     color: "white",
//     padding: "10px 6px",
//     fontSize: "0.85rem",
//     whiteSpace: "nowrap",
//     position: "sticky",
//     top: 0,
//     zIndex: 10
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: "10px 6px",
//     fontSize: "0.85rem",
//     verticalAlign: "middle",
//     backgroundColor: "white"
// };

// export default Foodsubscribedclients;





import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import { getSubscriptions } from "../../../Servicefile/clientManagementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Filter: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"/>
        </svg>
    ),
    Active: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Expired: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Pending: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        // background: '#f8f9fa',
        // borderRadius: '16px',
        // boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: '#e66d33',
        borderBottom: '2px solid #edf2f7',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusExpired: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    remainingBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3px 10px',
        borderRadius: '20px',
        fontWeight: '600',
        fontSize: '12px',
        minWidth: '40px'
    },
    remainingLow: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    remainingGood: {
        background: '#c6f6d5',
        color: '#276749'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0 0 0',
        fontSize: '12px',
        color: '#718096'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    amount: {
        fontWeight: '600',
        color: '#0b5e42'
    }
};

const Foodsubscribedclients = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCityFilter, setSelectedCityFilter] = useState("");
    const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

    // Search filters
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");

    const { showLoader, hideLoader } = useLoader();
    const [error, setError] = useState(null);

    // Business Vertical options
    const businessVerticalOptions = [
        "FOOD_AND_BEVERAGES",
        "CATERINGS_SERVICES",
        "LOGISTICS_SUPPLY",
        "FRESH_GROCERIES"
    ];

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Customer Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const formatShortDate = (isoString) => {
        if (!isoString) return "—";
        try {
            return new Date(isoString)
                .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });
        } catch (e) {
            return "—";
        }
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Customer Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            default: return "Search...";
        }
    };

    const getStatusStyle = (status) => {
        if (!status) return styles.statusDefault;
        const lower = status.toLowerCase();
        if (lower === 'active') return styles.statusActive;
        if (lower === 'expired') return styles.statusExpired;
        if (lower === 'pending') return styles.statusPending;
        return styles.statusDefault;
    };

    const getRemainingStyle = (days) => {
        if (days < 30) return styles.remainingLow;
        return styles.remainingGood;
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");

        if (!token) {
            console.warn("⚠️ No authToken found.");
            setError("Authentication token not found");
            hideLoader();
            return;
        }

        const fetchSubscriptions = async () => {
            try {
                showLoader();

                const subscriptions = await getSubscriptions(token);

                const mapped = (Array.isArray(subscriptions) ? subscriptions : [])
                    .map((s, idx) => ({
                        id: s.subscriptionId ?? idx,
                        vendorName: s.customerName || "—",
                        vendorId: s.vendorId || "—",
                        email: s.email || s.customerEmail || "—",
                        mobileNumber: s.customerMobile || "—",
                        city: s.city || "—",
                        businessVertical: s.businessVertical || "—",
                        startDate: s.startDate,
                        endDate: s.endDate,
                        billingCycle: s.billingCycle || "—",
                        totalAmount: s.totalAmount || 0,
                        status: s.status || "—",
                        selectedModules: s.selectedModules || [],
                        remainingDays: s.remainingDays || 0,
                        message: s.message || "",
                    }));

                setData(mapped);
                setError(null);

            } catch (err) {
                console.error("Error fetching subscriptions:", err);
                setError(err.message);

            } finally {
                hideLoader();
            }
        };

        fetchSubscriptions();

    }, []);

    const uniqueCities = useMemo(() => {
        const cities = data.map(item => item.city).filter(city => city && city !== "—");
        return [...new Set(cities)].sort();
    }, [data]);

    const uniqueStatuses = useMemo(() => {
        const statuses = data.map(item => item.status).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [data]);

    const uniqueBusinessVerticals = useMemo(() => {
        const verticals = data.map(item => item.businessVertical).filter(Boolean);
        return [...new Set(verticals)].sort();
    }, [data]);

    const filteredData = useMemo(() => {
        let result = data;

        if (selectedStatusFilter) {
            result = result.filter(item =>
                item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
            );
        }

        if (selectedCityFilter) {
            result = result.filter(item =>
                item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
            );
        }

        if (selectedBusinessVerticalFilter) {
            result = result.filter(item =>
                item.businessVertical === selectedBusinessVerticalFilter
            );
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.mobileNumber;
                } else if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "name") {
                    fieldValue = item.vendorName;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue || fieldValue === "—") return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        return result;
    }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery]);

    const clearAllFilters = () => {
        setSelectedStatusFilter("");
        setSelectedCityFilter("");
        setSelectedBusinessVerticalFilter("");
        setSearchQuery("");
        setSearchType("vendorId");
    };

    // Calculate stats
    const activeCount = data.filter(item => item.status?.toLowerCase() === 'active').length;
    const expiredCount = data.filter(item => item.status?.toLowerCase() === 'expired').length;
    const pendingCount = data.filter(item => item.status?.toLowerCase() === 'pending').length;
    const totalRevenue = data.reduce((sum, item) => sum + (item.totalAmount || 0), 0);

    return (
        <div style={styles.container}>
            {/* Header */}
            {/* <div style={styles.header}>
                <div style={styles.title}>
                    📋 Subscribed Clients
                    <span style={styles.titleBadge}>{filteredData.length}</span>
                </div>
                <div>
                    <button
                        onClick={() => window.location.reload()}
                        style={{ ...styles.button, ...styles.buttonPrimary }}
                    >
                        <Icons.Refresh /> Refresh
                    </button>
                </div>
            </div> */}

            {/* Filter Controls */}
            <div style={styles.filtersContainer}>
                <div style={styles.searchGroup}>
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.select}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <input
                        type="text"
                        placeholder={getPlaceholderText()}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            ...styles.input,
                            borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                        }}
                    />
                </div>

                <select
                    value={selectedStatusFilter}
                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Status</option>
                    {uniqueStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>

                <select
                    value={selectedCityFilter}
                    onChange={(e) => setSelectedCityFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Cities</option>
                    {uniqueCities.map(city => (
                        <option key={city} value={city}>{city}</option>
                    ))}
                </select>

                <select
                    value={selectedBusinessVerticalFilter}
                    onChange={(e) => setSelectedBusinessVerticalFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '130px' }}
                >
                    <option value="">All Verticals</option>
                    {uniqueBusinessVerticals.map(vertical => (
                        <option key={vertical} value={vertical}>{vertical}</option>
                    ))}
                </select>

                <button
                    onClick={clearAllFilters}
                    style={{ ...styles.button, ...styles.buttonSecondary }}
                >
                    <Icons.Clear /> Clear
                </button>

                {(searchQuery || selectedStatusFilter || selectedCityFilter || selectedBusinessVerticalFilter) && (
                    <span style={{ fontSize: '12px', color: '#718096' }}>
                        <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
                    </span>
                )}
            </div>

            {/* Stats Bar */}
            {/* <div style={styles.statsBar}>
                <span style={styles.statItem}>
                    Total: <span style={styles.statNumber}>{data.length}</span>
                </span>
                <span style={styles.statItem}>
                    Active: <span style={{ ...styles.statNumber, color: '#276749' }}>{activeCount}</span>
                </span>
                <span style={styles.statItem}>
                    Expired: <span style={{ ...styles.statNumber, color: '#9b2c2c' }}>{expiredCount}</span>
                </span>
                <span style={styles.statItem}>
                    Pending: <span style={{ ...styles.statNumber, color: '#975a16' }}>{pendingCount}</span>
                </span>
                <span style={styles.statItem}>
                    Revenue: <span style={{ ...styles.statNumber, color: '#0b5e42' }}>₹{totalRevenue.toLocaleString()}</span>
                </span>
                {(searchQuery || selectedStatusFilter || selectedCityFilter || selectedBusinessVerticalFilter) && (
                    <span style={{ color: 'rgb(230 109 51)', fontSize: '11px' }}>
                        ⚡ Filtered
                    </span>
                )}
            </div> */}

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                            <th style={styles.th}>Customer</th>
                            <th style={styles.th}>Vendor ID</th>
                            <th style={styles.th}>Email</th>
                            <th style={styles.th}>Phone</th>
                            <th style={styles.th}>City</th>
                            <th style={styles.th}>Vertical</th>
                            <th style={styles.th}>Billing</th>
                            <th style={{ ...styles.th, textAlign: 'right' }}>Amount</th>
                            <th style={styles.th}>Start</th>
                            <th style={styles.th}>End</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Remaining</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="13" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {error ? `⚠️ ${error}` : 
                                             data.length === 0 ? 'No subscriptions found' : 'No data matches your filters'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {data.length === 0 
                                                ? 'Please wait while we fetch the data'
                                                : 'Try adjusting your filters to see more results'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((item, index) => (
                                <tr
                                    key={item.id}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>
                                        {item.vendorName}
                                    </td>
                                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                        {item.vendorId}
                                    </td>
                                    <td style={{ ...styles.td, color: '#4a5568' }}>
                                        {item.email}
                                    </td>
                                    <td style={styles.td}>
                                        {item.mobileNumber}
                                    </td>
                                    <td style={styles.td}>
                                        {item.city}
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            fontSize: '11px',
                                            background: '#edf2f7',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            color: '#4a5568'
                                        }}>
                                            {item.businessVertical}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        {item.billingCycle}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'right', ...styles.amount }}>
                                        {item.totalAmount > 0
                                            ? `₹${item.totalAmount.toLocaleString()}`
                                            : "—"
                                        }
                                    </td>
                                    <td style={styles.td}>
                                        {formatShortDate(item.startDate)}
                                    </td>
                                    <td style={styles.td}>
                                        {formatShortDate(item.endDate)}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.remainingBadge,
                                            ...getRemainingStyle(item.remainingDays)
                                        }}>
                                            {item.remainingDays || 0}d
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.statusBadge,
                                            ...getStatusStyle(item.status)
                                        }}>
                                            {item.status}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Foodsubscribedclients;